// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2cd7ea7c","455":"08a7a42d"}[chunkId] + ".chunk.js";
};